module.exports = __webpack_public_path__ + "img/magnifying-glass.fba7da78.svg";